import { MIN_UNITS_B2B } from "../data/pricing";

export const PROD_ORIGIN = "https://www.viviconamoryarte.com";

export type FaqItem = {
  q: string;
  a: string;
  /**
   * Respuesta aún no confirmada por el negocio: se muestra como marco
   * provisional en la web y se excluye del JSON-LD `FAQPage`.
   */
  pending?: boolean;
};

export type ContactPoint = {
  telephone: string;
  contactType: string;
  availableLanguage?: string;
};

export type SiteConfig = {
  name: string;
  url: string;
  logo: string;
  sameAs: readonly string[];
  contactPoint?: ContactPoint;
};

export const SITE: SiteConfig = {
  name: "VIVI con Amor y Arte",
  url: PROD_ORIGIN,
  logo: `${PROD_ORIGIN}/og-image.png`,
  sameAs: [
    "https://www.instagram.com/viviconamoryarte/",
    "https://www.tiktok.com/@viviconamoryarte7",
    "https://x.com/Viviana00811243",
  ],
  contactPoint: {
    telephone: "+50761568575",
    contactType: "customer service",
    availableLanguage: "es",
  },
};

// Provisional: la operadora cura estos textos en la revisión de la HU.
export const KEYWORDS_PROVISIONALES = [
  "agendas personalizadas Panamá",
  "planner personalizado con logo",
  "libreta personalizada Panamá",
  "agenda pediátrica con logo",
  "merch corporativo con logo",
];

export const FAQ: FaqItem[] = [
  {
    q: "¿Cuál es el pedido mínimo para empresas?",
    a: `Producimos pedidos corporativos desde ${MIN_UNITS_B2B} unidades por diseño, con precio especial por volumen.`,
  },
  {
    q: "¿Puedo convertir mi método o mi contenido en un planner propio?",
    a: `Sí. Trabajamos con psicólogos, coaches y creadores que traen su contenido: nosotras nos encargamos del diseño, la muestra y la producción con tu marca, desde ${MIN_UNITS_B2B} unidades.`,
  },
  {
    q: "¿En qué formato les envío el logo?",
    a: "Lo ideal es un archivo vectorial (SVG, AI o PDF) o un PNG de alta resolución. Si no lo tienes, te ayudamos a prepararlo.",
  },
  {
    q: "¿Qué formas de pago aceptan?",
    a: "Aceptamos tarjeta (Visa y Mastercard) y Yappy. Las condiciones para pedidos por volumen se detallan en tu cotización.",
  },
  {
    q: "¿Cuánto tardan en producir y entregar?",
    a: "Definimos el cronograma contigo al confirmar el pedido; el tiempo depende del volumen y de la fecha objetivo.",
    pending: true,
  },
  {
    q: "¿En cuánto tiempo responden una cotización?",
    a: "Te respondemos en horario de atención; el tiempo estimado de respuesta lo confirmamos al enviar tu solicitud.",
    pending: true,
  },
  {
    q: "¿Piden anticipo en pedidos por volumen?",
    a: "Las condiciones de pago por volumen se acuerdan y detallan en tu cotización.",
    pending: true,
  },
  {
    q: "¿Emiten factura fiscal?",
    a: "Consúltanos tus necesidades de facturación al momento de cotizar.",
    pending: true,
  },
  {
    q: "¿Hacen pedidos corporativos con el logo de mi empresa?",
    a: "Sí. Realizamos producción personalizada con tu logo para empresas y pedidos por volumen.",
  },
  {
    q: "¿Realizan entregas en Panamá?",
    a: "Sí, con entrega a domicilio en Ciudad de Panamá y envíos al resto del país.",
  },
  {
    q: "¿Cómo pido una cotización o hago un pedido?",
    a: "Puedes solicitar tu cotización desde la web o escribirnos por WhatsApp al +507 61568575, disponible de 8:00 AM a 8:00 PM.",
  },
];
